export default __webpack_public_path__ + "static/N0087-dfc7b937188849e20ad2da1f3f774eda.png";